// AuthPage.js
import React, { useState } from 'react';
import { Register } from './register';
import { Login } from './../pages/login';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const AuthPage = () => {
  const [showRegister, setShowRegister] = useState(false);

  const handleSwitchToLogin = () => setShowRegister(false);
  const handleSwitchToRegister = () => setShowRegister(true);

  return (
    <>
      {/* <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
        style={{ zIndex: 999999 }}
      /> */}

      {/* En lugar de condicionar con ? : , montamos ambos,
          y controlamos visibilidad con style. */}
      <div style={{ display: showRegister ? 'none' : 'block' }}>
        <Login onSwitchToRegister={handleSwitchToRegister} />
      </div>
      <div style={{ display: showRegister ? 'block' : 'none' }}>
        <Register onSwitchToLogin={handleSwitchToLogin} />
      </div>
    </>
  );
};
